import { render, staticRenderFns } from "./BankSlip.vue?vue&type=template&id=44586e66&scoped=true&"
import script from "./BankSlip.vue?vue&type=script&lang=js&"
export * from "./BankSlip.vue?vue&type=script&lang=js&"
import style0 from "./BankSlip.vue?vue&type=style&index=0&id=44586e66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44586e66",
  null
  
)

export default component.exports